import { BusinessRelationType } from '~/types/api/contacts/contact-summary';
export function toContactSummary(contact) {
    var _contact_phone;
    const contactId = contact.contactId();
    if (contactId == null) return null;
    const userId = contact.userId();
    return {
        contactId,
        firstName: contact.firstName(),
        lastName: contact.lastName(),
        email: contact.email(),
        phone: (_contact_phone = contact.phone()) !== null && _contact_phone !== void 0 ? _contact_phone : undefined,
        relation: userId != null ? {
            type: BusinessRelationType.Native,
            native: {
                userId
            }
        } : {
            type: BusinessRelationType.NoRelation
        }
    };
}
export const singleContactSummary = (summaries)=>{
    var _summaries_;
    return (_summaries_ = summaries[0]) !== null && _summaries_ !== void 0 ? _summaries_ : null;
};
export const createdClientContactId = (param)=>{
    let { contacts, clientId, createdId, keepUnresolvedId } = param;
    var _ref;
    const added = contacts.find((contact)=>contact.customerId() === clientId && contact.matchesCreatedContactId(createdId));
    return (_ref = added === null || added === void 0 ? void 0 : added.id()) !== null && _ref !== void 0 ? _ref : keepUnresolvedId ? createdId : null;
};
